window.addEventListener('DOMContentLoaded', () => {

    var product_recommendations = new Swiper(".hobo-product-recommendations-carousel", {
      slidesPerView: 1.25,
      centeredSlides: false,
      spaceBetween: 22,
      navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
      },
      breakpoints: {
          640: {
            slidesPerView: 2
          },
          1024: {
            slidesPerView: 4
          }
      }
    })
    var featured_collection_carousel = new Swiper(".featured-collection-carousel", {
        slidesPerView: 1.25,
        centeredSlides: false,
        spaceBetween: 22,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            640: {
              slidesPerView: 2
            },
            1024: {
              slidesPerView: 4
            }
        }
    })

    const seeMoreCarousel = document.querySelector('.see-more-carousel')
    if(seeMoreCarousel){

      const slideWrapper = seeMoreCarousel.querySelector('.swiper-wrapper')
      const slideCount = Array.from(slideWrapper.children).length
      const isMobile = window.matchMedia("(max-width: 640px)").matches
      let loopSlides = false;
  
      if (isMobile){
        loopSlides = slideCount > 2 ? true : false;
      } else {
        loopSlides = slideCount > 4 ? true : false;
      }
  
      var see_more_carousel = new Swiper(".see-more-carousel", {
        slidesPerView: 2.25,
          centeredSlides: false,
          spaceBetween: 22,
          loop: loopSlides,
          navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
          },
          breakpoints: {
            640: {
              slidesPerView: 2.25,
            },  
            1024: {
                slidesPerView: 4,
              }
          }
      })
  
    }
    const editorial_product_carousel_check = document.querySelector('.hobo-product-slider .editorial-product-carousel')
    if(editorial_product_carousel_check){
      var editorial_product_carousel = new Swiper(".hobo-product-slider .editorial-product-carousel", {
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    })
  }

/// PDP YOU MAY ALSO LIKE PRODUCT RECOMMENDATIONS INITIATES IN THEME.JS 
/// WITHIN  theme.Recommendations = (function() {})
/// CONTAINER CLASSNAME IS product-recommendations-carousel-container
})